<template>
    <div>
        <div
            style="width: 100%;margin-top: 20px;display: flex;flex-direction: column; justify-content: center;align-items: center;">
            <my-text-one :title="teamName + '团队建设'" :textContent="teamName + '团队建设'"></my-text-one>
            <div style="width: 70%;margin-top: 50px">
                <el-tabs :stretch="true" v-model="activeName" @tab-click="handleClick">
                    <el-tab-pane name="0">
                        <span slot="label">教学</span>
                    </el-tab-pane>
                    <el-tab-pane name="1">
                        <span slot="label">团建</span>
                    </el-tab-pane>
                    <el-tab-pane name="2">
                        <span slot="label">荣誉</span>
                    </el-tab-pane>
                    <el-tab-pane name="3">
                        <span slot="label">合作</span>
                    </el-tab-pane>
                    <el-tab-pane name="4">
                        <span slot="label">文件</span>
                    </el-tab-pane>
                </el-tabs>

            </div>
            <div class="list-view" :style="{ height: screenHeight }">
                <el-row :gutter="20" >
                    <el-col :span="6" v-for="(item,i) in videoList" :key="i" @click="currentIndex = i" v-if="selectTabName == item.type">
                        <div style="width: 100%;" >
                            <!-- <van-image width="100%" height="90px" fit="cover" :src="videoList[i - 1].imgUrl" /> -->
                            <el-image style="width: 100%;height: 380px;" :src="item.imgUrl" fit="cover"
                                :preview-src-list="[item.imgUrl]">
                            </el-image>
                        </div>

                    </el-col>

                </el-row>
            </div>
        </div>

        <div class="kuang">
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
            <div class="bubble"></div>
        </div>
    </div>
</template>

<script>
import MyTextOne from "@/components/MyTextOne.vue";

export default {
    components: {
        MyTextOne,
    },
    data() {
        return {
            // 屏幕宽度
            screenWidth: window.screen.width,
            // 屏幕高度
            screenHeight: window.screen.height - 450 + "px",
            // 分屏布局
            playerNum: 0,
            colSpan: 24,
            currentIndex: 0,
            // 视频播放器
            muted: false,
            autoplay: false,
            videoList: [],

            dataForm: {
                key: "",
            },
            pageIndex: 1,
            pageSize: 40,
            dataListLoading: false,
            dataListSelections: [],
            addOrUpdateVisible: false,

            currentIndex: 0,
            activeName: "0",
            selectTabName: 0,
            selectScale: -1,
        };
    },
    computed: {
      teamName () {
        return (this.$store && this.$store.state.brand && this.$store.state.brand.teamName) || '音愈童心'
      }
    },
    methods: {
        handleClick(tab, event) {
            this.selectTabName = Number(tab.name);
            console.log(this.selectTabName);
        },
        // 获取数据列表
        getDataList() {
            this.dataListLoading = true;
            this.$http({
                url: this.$http.adornUrl("/app/picture/list"),
                method: "get",
                params: this.$http.adornParams({
                    page: this.pageIndex,
                    limit: this.pageSize,
                    key: this.dataForm.key,
                }),
            }).then(({ data }) => {
                console.log(data);
                if (data && data.code === 0) {
                    this.videoList = data.page.list;
                    this.playerNum = data.page.totalCount;
                } else {
                    this.videoList = [];
                    this.totalPage = 0;
                }
                this.dataListLoading = false;
            });
        },
        imagePreview(i) {
            ImagePreview({
                images: [
                    this.videoList[i].imgUrl,
                ],
                closeable: true,
            });

        },
        goVideoContent(index) {
            console.log(index);
            let data = this.videoList[index];
            console.log(data);
            this.$router.push({
                name: "VideoContentMobile",
                params: {
                    data: data,
                },
            });
        },

    },
    mounted() {
        this.getDataList();
        console.log(this.screenHeight);
    },
    created() { },
}
</script>
<style lang="less" scoped>
.van-nav-bar {
    background-color: #00000000;
}

audio {

    display: block;
    width: 250px;
    height: 40px;
    outline: none;
    filter: invert(180);
}


/* 自定义进度条样式 */
audio::-webkit-media-controls-progress-bar {
    height: 5px;
    /* 设置进度条高度 */
}

/* 自定义进度条填充样式 */
audio::-webkit-media-controls-play-button,
audio::-webkit-media-controls-volume-slider,
audio::-webkit-media-controls-timeline,
audio::-webkit-media-controls-mute-button,
audio::-webkit-media-controls-volume-slider-container,
audio::-webkit-media-controls-overflow-button audio::-webkit-media-controls-timeline-container {
    display: none !important;
    /* 隐藏默认控制按钮和音量控制条 */
}

// /* 自定义播放按钮样式 */
// audio::-webkit-media-controls-play-button {
//   width: 20px; /* 设置播放按钮宽度 */
//   height: 20px; /* 设置播放按钮高度 */
// }

// /* 自定义音量控制按钮样式 */
// audio::-webkit-media-controls-volume-slider {
//   width: 50px; /* 设置音量控制按钮宽度 */
//   height: 5px; /* 设置音量控制按钮高度 */
// }

// /* 自定义时间显示样式 */
// audio::-webkit-media-controls-current-time-display,
// audio::-webkit-media-controls-time-remaining-display {
//   font-size: 12px; /* 设置时间显示字体大小 */
// }

// /* 自定义音量控制按钮样式 */
// audio::-webkit-media-controls-volume-slider {
//   width: 50px; /* 设置音量控制按钮宽度 */
//   height: 5px; /* 设置音量控制按钮高度 */
// }

// /* 自定义音量控制滑块样式 */
// audio::-webkit-media-controls-volume-slider::-webkit-media-slider-thumb {
//   width: 10px; /* 设置音量控制滑块宽度 */
//   height: 10px; /* 设置音量控制滑块高度 */
// }
/* 需要滚动条隐藏的列表 */
.list-view {
    width: 90%;
    // height: 700px;
    margin-top: 10px;
    overflow-x: hidden;
    overflow-y: auto;
    // background-color: yellow;
}

/* 隐藏滚动条 */
.list-view::-webkit-scrollbar {
    display: none;
}

.el-card {
    --background-opacity: 0.15;
    background-color: rgba(255, 255, 255, var(--background-opacity)) !important;

    box-shadow: 0 5px 15px rgba(20, 20, 20, 0.6) !important;

    backdrop-filter: blur(50px) !important;
    border: none !important;
    border-radius: 5px !important;
    //    opacity: 0.75;
}

.el-card.selected {
    --background-opacity: 0.3;
    /* 修改选中时的透明度 */
}

.el-row {
    margin-bottom: 20px;
}

.el-row:last-child {
    margin-bottom: 0;
}

.el-col {
    border-radius: 4px;
    margin-bottom: 20px
}

.grid-content {
    border-radius: 4px;
    min-height: 36px;
}

/deep/ .el-tabs__nav {
    // width: 10px;
    //   font-size: 29px;
    // line-height: 55px;
    height: 45px;
}


::v-deep .el-tabs__item.is-active {
    color: skyblue; //选中
    opacity: 1;
}

::v-deep .el-tabs__item:hover {
    color: skyblue; //悬浮
    cursor: pointer;
    opacity: 1;
}

/deep/.el-tabs__item {
    /* 修改为您想要的文字大小 */
    font-size: 20pt !important;
    color: #fff;
    font-weight: bold;
}

/deep/.el-tabs__nav-wrap::after {
    /* 去掉下划线 */
    position: static !important;
}

/* 下划线颜色 */
::v-deep .el-tabs__active-bar {
    background-color: skyblue;
}

.obstacles-container {
    position: relative;
    width: 100%;
}


/**背景 **/

* {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
}

.kuang {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: -10;
    background-image: linear-gradient(180deg, rgb(0, 6, 31), rgb(0, 2, 20));

}

.bubble {
    position: absolute;
    border-radius: 50%;
    border: 2px solid #fff;
    box-shadow: inset 0 0 8px #fff;
    animation: flutter 10s infinite;
    opacity: 0;
}

@keyframes flutter {
    0% {
        transform: translateX(0);
        bottom: -100px;
        opacity: 1;
    }

    50% {
        transform: translateX(100px);
        opacity: 0.5;
    }


    100% {
        transform: translateX(0px);
        bottom: 100%;
        opacity: 0;

    }
}

.bubble:nth-child(1) {
    left: -10%;
    width: 50px;
    height: 50px;
    animation-duration: 9s;
    animation-delay: 0.1s;
}

.bubble:nth-child(2) {
    left: 15%;
    width: 20px;
    height: 20px;
    animation-duration: 6s;
    animation-delay: 1.5s;

}

.bubble:nth-child(3) {
    left: 20%;
    width: 60px;
    height: 60px;
    animation-duration: 10s;



}

.bubble:nth-child(4) {
    left: 30%;
    width: 30px;
    height: 30px;
    animation-duration: 5.5s;
    animation-delay: 1.5s;

}

.bubble:nth-child(5) {
    left: 40%x;
    width: 50px;
    height: 50px;
    animation-duration: 12s;



}

.bubble:nth-child(6) {
    left: 50%;
    width: 20px;
    height: 20px;
    animation-duration: 6s;
    animation-delay: 1s;

}

.bubble:nth-child(7) {
    left: 60%;
    width: 40px;
    height: 40px;
    animation-duration: 8s;
    animation-delay: 1s;

}

.bubble:nth-child(8) {
    left: 65%;
    width: 60px;
    height: 60px;
    animation-duration: 15s;

}

.bubble:nth-child(9) {
    left: 80%;
    width: 55px;
    height: 55px;
    animation-duration: 9s;
    animation-delay: 0.5s;

}

.bubble:nth-child(10) {
    left: 100%;
    width: 40px;
    height: 40px;
    animation-duration: 12s;

}
</style>